import { variableType_Normal } from '@app/hcs-shared';
export const generalId = '00000000000000000000000000000000';
export const allDPsId = 'ffffffffffffffffffffffffffffffff';
export const Const_Admit = 'Admit';
export const Const_Discharge = 'Discharge';
export const Const_Consult = 'Consultation By';
export const Const_AdditionalConsults = 'Additional Consultation';
export const generalDP = {
    _id: generalId,
    __created: 0,
    __updated: 0,
    _v: '',
    chiefComplaintIds: ['35f333d8481bea7133eaac673be8c738'],
    completed: true,
    criticality: 'criticality-00',
    icd: [],
    colorGroup: '',
    initials: 'GENERAL',
    label: 'Initial Chest Pain',
    profileDescription: 'General Disease Profile',
    referenceIds: [],
    scores: '',
    tagIds: [],
    variableId: generalId,
    _tagIds: [],
    _valueIds: [],
    _variableIds: []
};
export const generalVariable = {
    _id: generalId,
    __created: 0,
    __updated: 0,
    _attributeValueIds: [],
    _attributeVarIds: [],
    _nameInLowercase: 'general',
    type: variableType_Normal,
    _tagIds: [],
    attributes: [],
    name: 'general',
    // Not like all other variable templates, this one is not clear to me,
    // general variable that includes nothing should not appear in the advisor therefore the default value here will be false
    showInAdvisor: false,
    nlpDataId: '',
    otherProperties: {},
    perspective: 'objective',
    referenceIds: [],
    tagIds: [],
    valueId: ''
};
//# sourceMappingURL=consts.js.map